import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesSelfManagementComponent} from "./sales-self-management.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    SalesSelfManagementComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SalesSelfManagementModule { }
